/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SimpleTimeWorkedCalculationRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {OvertimeReportByTimecardForEmployeeResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const overtimeReportByTimecardForEmployee = (request: SimpleTimeWorkedCalculationRequest, options?: CashRequestOptions) => post<SimpleTimeWorkedCalculationRequest, OvertimeReportByTimecardForEmployeeResponse>("/proxy/services/squareup.timecards.TimeCalculationReportService/OvertimeReportByTimecardForEmployee", request, {...options, rejectOnError: true })